// extracted by mini-css-extract-plugin
module.exports = {"overlay":"_1rPK5","modal":"_2LAsr","container":"_1tS_R","closeButton":"_2kr5p","header":"xdm7S","rtl":"_30M-m","body":"_140G4"};